<template lang="html">
  <div class="timer" :class="{ warning: minutes < 2 }">
    <span class="description">{{ $tr('videoInterview.test.timeRemaining') }}</span>
    <span class="time">{{ minutes }}:{{ seconds }}</span>
  </div>
</template>

<script>
import Moment from 'moment'
import Zeropad from 'zeropad'

export default {
  name: 'timer',

  props: {
    time: Date,
    // time limit in seconds
    timeLimit: Number
  },

  methods: {
    startTimer () {
      this.timeEnds = Moment(this.time).add(this.timeLimit, 'seconds').unix()
      this.timer = setInterval(this.tick, 500)
    },

    tick () {
      const diff = this.timeEnds - Moment().unix()
      this.duration = Moment.duration(diff * 1000, 'milliseconds')
    },

    stopTimer () {
      clearInterval(this.timer)
    }
  },

  watch: {
    seconds () {
      if (this.minutes <= 0 && this.seconds <= 0) {
        this.stopTimer()
        this.$emit('timeIsOver')
      }
    }
  },

  computed: {
    minutes () {
      return Zeropad(this.duration.minutes())
    },

    seconds () {
      return Zeropad(this.duration.seconds())
    }
  },

  data () {
    return {
      timer: null,
      timeEnds: null,
      duration: Moment.duration()
    }
  },

  beforeMount () {
    this.startTimer()
    this.tick()
  },

  beforeDestroy () {
    this.stopTimer()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../styles/colors.scss";
  @import "../../../../../styles/queries.scss";

  .timer {
    display: block;
    position: fixed;
    top: 20px;
    left: 20px;
    width: 120px;
    height: 48px;
    font-size: 12px;
    color: $light-grey-color;
    font-weight: 100;
    text-align: center;
    z-index: 9999;
    box-sizing: border-box;
    border: 1px solid;
    border-radius: 4px;
    padding: 4px 6px;

    @include mobile {
      top: 10px;
      left: 0;
      right: 0;
      margin: auto;
    }

    &.warning {
      color: $red-color;
    }

    .time {
      font-size: 18px;
      letter-spacing: 0.05em;
    }
  }
</style>
